import mixpanel from 'mixpanel-browser';

const mixpanelToken = "dabc8585283965525343c3431fb1dbde";

export const mixpanelInit = () => {
  if (mixpanelToken) {
    mixpanel.init(mixpanelToken, {
      api_host: 'https://drdun9bya6vw5.cloudfront.net',
      persistence: 'localStorage',
      track_pageview: true,
    });
  }
};

function extractOrganizationName(email) {

  if(email){
    const parts = email?.split("@");

  // Check if the split operation resulted in two parts (username and domain)
  if (parts?.length === 2) {
      // Split the domain part by the dot (.) symbol
      const domainParts = parts[1]?.split(".");

      // If domainParts has more than one part, take the first part as the organization name
      if (domainParts?.length > 1) {
          return domainParts[0];
      } else {
          // If domainParts has only one part, return that as the organization name
          return parts[1];
      }
  } else {
      // If the email doesn't contain an "@" symbol, return null
      return null;
  }
  }else{
    return null
  }
}

export const mixpanelAppRegister = (email,role) => {
  let organisation = "ripik";
  if(email == "optimus@ripik.in"){
    organisation = "imfa"
  }
  if (mixpanelToken) {
    mixpanel.identify(email);
    mixpanel.people.set('$email', email);
    mixpanel.people.set('organisation', organisation)
    mixpanel.people.set('role', role)
    mixpanel.register({
      email: email,
      organisation: organisation,
      tool:"imfa_burden_mix",
      role:role
    });
  }
};

export const mixpanelPathnameEvent = (pathname) => {
  if (mixpanelToken) {
    let str = pathname?.split('/')?.slice(1)?.reverse()?.join(' ') || "home";
    if(str === "editAssumptions"){
        str = "assumptions"
    }else if(str === "output"){
        str = "latest"
    }
    mixpanel.track(`${str} page visited`);
    }
};

export const mixpanelLoginFunction = (data) => {
    let organisation = "ripik";
    if(data?.email == "optimus@ripik.in"){
      organisation = "imfa"
    }
  if (mixpanelToken) {
    mixpanel.identify(data?.email);
    mixpanel.people.set('$email', data?.email);
    mixpanel.people.set('organisation',organisation);
    mixpanel.people.set('role', data?.role)
    mixpanel.register({
      email: data?.email,
      organisation: organisation,
      tool:"imfa_burden_mix",
      role:data?.role
    });
    mixpanel.track('User login', {
      email: data?.email,
    });
  }
};

export const mixpanelTrackTabs = (tab, page) => {
  
  if (mixpanelToken) {
    mixpanel.track('Tab switch', {
      page:page,
      tab: tab,
      tool:"imfa_burden_mix"
    });
  }
};

export const mixpanelTrackButton = ( page, buttonClicked) => {
  if (mixpanelToken) {
      mixpanel.track('Button clicked', {
      page: page,
      buttonClicked: buttonClicked,
      tool:"imfa_burden_mix"
    });
  }
};
